import { render, staticRenderFns } from "./SalesRecord2.vue?vue&type=template&id=1b6aa6c8&scoped=true&"
import script from "./SalesRecord2.vue?vue&type=script&lang=js&"
export * from "./SalesRecord2.vue?vue&type=script&lang=js&"
import style0 from "./SalesRecord2.vue?vue&type=style&index=0&id=1b6aa6c8&prod&lang=scss&scoped=true&"
import style1 from "./SalesRecord2.vue?vue&type=style&index=1&id=1b6aa6c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6aa6c8",
  null
  
)

export default component.exports